import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, FilteredCommand } from '../../../core/model/command';
import { mailCommand } from '../../model/const/command';
import { MailService } from '../data/mail.service';
import { MessageService } from '../../../core/service/message.service';
import { Observable, finalize, catchError } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class SendMailCommandHandler implements ICommandHandler {
  constructor(
    private _service: MailService,
    private _messageService: MessageService,
    private readonly _progressBar: ProgressBarService,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command.id == mailCommand.send;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._service.send(command.context.id).pipe(
        map(mail => {
          Object.assign(command.context, mail);
        }),
        catchError(e => {
          this._messageService.showError(e);
          throw e;
        })
      );
    } else if (command instanceof FilteredCommand) {
      try {
        this._progressBar.start();
        return this._service
          .sendLetterFiltered(
            command.filterProvider.filterState,
            command.includedIds,
            command.excludedIds,
            command.totalAffectedItemsControlValue
          )
          .pipe(
            map(_ => {
              this._navigationService.reloadCurrentRoute();
            }),
            finalize(() => this._progressBar.stop()),
            catchError(e => {
              this._messageService.showError(e);
              throw e;
            })
          );
      } catch {
        this._progressBar.stop();
      }
    }
  }
}
